import {FluidReplacementAfterMonthsInput} from '../components/FluidReplacementAfterMonthsInput';
import {LastFluidReplacementDatePicker} from '../components/LastFluidReplacementDatePicker';
import {LastFluidReplacementMileageInput} from '../components/LastFluidReplacementMileageInput';
import {NextFluidReplacementDatePicker} from '../components/NextFluidReplacementDatePicker';

export function CoolantFluidReplacementGroup() {
  return (
    <>
      <LastFluidReplacementDatePicker name="coolantFluid" />
      <LastFluidReplacementMileageInput name="coolantFluid" />
      <FluidReplacementAfterMonthsInput name="coolantFluid" />
      <NextFluidReplacementDatePicker name="coolantFluid" />
    </>
  );
}
